import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';

export const TimecardAdminApprovalModal = ({
  open,
  onClose,
  onApprove,
  weekEndingDate,
  foremanName,
  summaryData,
}) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    } catch (error) {
      return dateString;
    }
  };

  const handleClose = () => {
    setReason('');
    setError('');
    onClose();
  };

  const handleApprove = () => {
    if (!reason.trim()) {
      setError('Please provide a reason for approving on behalf');
      return;
    }
    setError('');
    onApprove(reason);
    setReason('');
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Approve Time on Behalf of {foremanName}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" paragraph>
          You are approving time for <strong>{foremanName}</strong> for week
          ending {formatDate(weekEndingDate)}.
        </Typography>

        <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
          Summary:
        </Typography>

        <Box sx={{ pl: 2, mb: 3 }}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            • Total Hours: {summaryData.totalHours.toFixed(1)}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            • Total Entries: {summaryData.totalEntries}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            • Straight Time: {summaryData.straightTime.toFixed(1)}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            • Overtime: {summaryData.overtime.toFixed(1)}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            • Double Time: {summaryData.doubleTime.toFixed(1)}
          </Typography>
        </Box>

        <Alert severity="warning" sx={{ mb: 2 }}>
          You are approving this timecard on behalf of a foreman. A reason is
          required for audit purposes.
        </Alert>

        <TextField
          fullWidth
          multiline
          rows={4}
          label="Reason for approving on behalf (required)"
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            if (error) setError('');
          }}
          placeholder="Enter reason for approving on behalf..."
          variant="outlined"
          error={!!error}
          helperText={error}
          required
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleClose} variant="outlined" sx={{ minWidth: 120 }}>
          Cancel
        </Button>
        <Button
          onClick={handleApprove}
          variant="contained"
          color="primary"
          sx={{ minWidth: 120 }}
        >
          Approve on Behalf
        </Button>
      </DialogActions>
    </Dialog>
  );
};
